module.exports = __webpack_public_path__ + "static/media/cotiza-cajas-01.27136497.svg";